import { ApiType } from "@gymflow/common/lib/api/ApiType";
import { useInfiniteQuery } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export const useInfiniteQueryUserMemberSessionPackSubscriptionPrevious = ({
  api,
  userMemberId,
  enabled,
}: {
  api: ApiType;
  userMemberId: string;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      memberQueryKeys.userMemberSessionPackSubscriptionPrevious(userMemberId),
    queryFn: async ({ pageParam }) =>
      (
        await api.memberApi.userMemberSessionPackSubscriptionPrevious({
          userMemberId,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
  });
